import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { NeighborhoodWithCity } from "@/types/neighborhood";

interface NeighborhoodFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export const NeighborhoodFilter = ({ value, onChange }: NeighborhoodFilterProps) => {
  const { data: neighborhoods } = useQuery({
    queryKey: ['neighborhoods'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('neighborhoods')
        .select(`
          id,
          name,
          city_id,
          city:cities(name, state)
        `)
        .eq('city.name', 'New York City');
      
      if (error) throw error;
      return data as NeighborhoodWithCity[];
    }
  });

  return (
    <Select value={value || "all"} onValueChange={onChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Neighborhoods" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">Neighborhoods</SelectItem>
        {neighborhoods?.map((neighborhood) => (
          <SelectItem key={neighborhood.id} value={neighborhood.name}>
            {neighborhood.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};